const sortKeys = {
  sale: 'closeDt',
  lease: 'leaseDt',
  incexp: 'incStYr',
  const: 'constYr'
}

/**
 * Get sorted transactions by the transactions date
 * @param  {Immutable<List>}  transactions list of transactions
 * @param  {String} type      transaction  identifier
 * @return {Immutable<List>}               sorted list of transactions
 */
export default function sortTransactionsByDate (transactions, type) {
  const sortKey = sortKeys[type]

  return transactions.sort((a, b) => {
    const keyA = new Date(a.get(sortKey))
    const keyB = new Date(b.get(sortKey))

    if (keyA < keyB) return 1
    if (keyA > keyB) return -1

    return 0
  })
}



// WEBPACK FOOTER //
// ./modules/utils/sortTransactionsByDate.js